import apiClient from '../axios/client.js';

/**
 * Inventory API service
 * Handles all inventory-related API calls
 */
class InventoryApiService {
  /**
   * Search products by code or description
   * @param {string} searchTerm - The search term (product code or description)
   * @returns {Promise<Array>} Array of product suggestions
   */
  async searchProducts(searchTerm) {
    try {
      const response = await apiClient.get('/inventory/search', {
        params: { codigoProduto: searchTerm }
      });
      
      // Expect JSON response with product data
      return response.data;
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  }

  /**
   * Get product suggestions (for autocomplete)
   * @param {string} term - Search term
   * @returns {Promise<Array>} Array of product suggestions
   */
  async getProductSuggestions(term) {
    try {
      const response = await apiClient.get('/inventory/suggestions', {
        params: { term }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting product suggestions:', error);
      throw error;
    }
  }

  /**
   * Get product details by code
   * @param {string} productCode - Product code
   * @returns {Promise<Object>} Product details
   */
  async getProductDetails(productCode) {
    try {
      const response = await apiClient.get(`/api/inventory/products/${productCode}`);
      return response.data;
    } catch (error) {
      console.error('Error getting product details:', error);
      throw error;
    }
  }
}

const inventoryApiService = new InventoryApiService();
export default inventoryApiService;
